import {
    ApolloClient,
    createHttpLink,
    InMemoryCache,
    NormalizedCacheObject,
  } from "@apollo/client";
  import { setContext } from "@apollo/client/link/context";
  import { getStorageToken } from "../utils/localStorage";
  import { typeDefs } from "./schema";
  import ApolloLinkTimeout from "apollo-link-timeout";

  export class GraphqlClient {
    private static client: ApolloClient<NormalizedCacheObject>;
  
    public static getInstance(forceNew?: boolean) {
      if (!GraphqlClient.client || forceNew) {
        const authLink = setContext((_, { headers }) => {
          const localStorageToken = getStorageToken();

          return {
            ...headers,
            headers: {
              Authorization:
                localStorageToken
                  ? `Bearer ${localStorageToken}`
                  : "",
            },
          };
        });
  
        const timeoutLink = new ApolloLinkTimeout(120000);
        const uri = process.env.REACT_APP_GRAPHQL_API_URL!;

        const httpLink = createHttpLink({
          uri: uri,
        });
  
        GraphqlClient.client = new ApolloClient({
          cache: new InMemoryCache(),
          link: timeoutLink.concat(authLink.concat(httpLink)),
          typeDefs,
        });
      }
  
      return GraphqlClient.client;
    }
  }
  